<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Composição do exame"
    >

        <Form
            :data="data"
            :item="item"
            :index="index"
            @save="handleExit"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="$refs.Form.add()"
                color="primary"
            >
                {{ index == null ? 'Incluir' : 'Alterar' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null,
    }),
    methods: {
        open(index, item) {

            this.index = index
            this.item = item

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>